var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3561_3137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9889 15.1363L2.46891 13.6162C1.84891 12.9962 1.84891 11.9762 2.46891 11.3562L3.9889 9.83622C4.2489 9.57622 4.4589 9.06621 4.4589 8.70621V6.55619C4.4589 5.67619 5.1789 4.95621 6.0589 4.95621H8.2089C8.5689 4.95621 9.0789 4.74624 9.3389 4.48624L10.8589 2.96622C11.4789 2.34622 12.4989 2.34622 13.1189 2.96622L14.6389 4.48624C14.8989 4.74624 15.4089 4.95621 15.7689 4.95621H17.9189C18.7989 4.95621 19.5189 5.67619 19.5189 6.55619V8.70621C19.5189 9.06621 19.7289 9.57622 19.9889 9.83622L21.5089 11.3562C22.1289 11.9762 22.1289 12.9962 21.5089 13.6162L19.9889 15.1363C19.7289 15.3963 19.5189 15.9063 19.5189 16.2663V18.4162C19.5189 19.2962 18.7989 20.0163 17.9189 20.0163H15.7689C15.4089 20.0163 14.8989 20.2262 14.6389 20.4862L13.1189 22.0063C12.4989 22.6263 11.4789 22.6263 10.8589 22.0063L9.3389 20.4862C9.0789 20.2262 8.5689 20.0163 8.2089 20.0163H6.0589C5.1789 20.0163 4.4589 19.2962 4.4589 18.4162V16.2663C4.4589 15.8963 4.2489 15.3863 3.9889 15.1363Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.4758L15 9.47583",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4945 14.9758H14.5035",
    stroke: "#AED100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49451 9.97583H9.50349",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3561_3137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.47583)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.11de5b3a86aa372a2ef30bb9cfa1c0ff.svg";
export { ForwardRef as ReactComponent };